export const reviewItems =  [
  {
    name: "Simeon Tan",
    time: "2 months ago",
    review:
      "Been using value print for my business marketing materials. The Boss is highly responsive and responsible. Quality of print is great and priced reasonably! The turn around time is amazing within a day! Definitely my goto printer for print media!!",
  },
  {
    name: "Jo Teh",
    time: "2 months ago",
    review: 
    
`Ricky was immensely helpful and responsive. Had an urgent print order and Ricky expedited for us immediately. The print quality was excellent as well!

    Really appreciate his thoughtfulness and meticulous effort throughout and impressed by the high standards.`,
   
  },
  {
    name: "Viktoria T. Christensen",
    time: "3 months ago",
    review: "Owner is super friendly and delivers great service and work! I didn’t have the original working files, but he and his team did a good job finding a solution to work around it anyway. Product looks great and high quality. He also facilitated an easy way for me to pay as I did not have cash or PayNow — I really appreciate little efforts like that and will definitely return as a customer!",
  },
  {
    name: "Brendan Seah",
    time: "4 months ago",
    review: "I work closely with Ricky to print Daughters Of Tomorrow women's programme handbook. Very prompt, reliable and excellent quality printing. Highly recommended!",
  },
  {
    name: "Candice Miller",
    time: "6 months ago",
    review: "Great service by Ricky! WhatsApp makes it super easy to communicate. Emailed him the files. He was able to accommodate me for same day printing and pick up. Payment was using pay now and very efficient! Good prices!",
   
  },
  {
    name: "Matt K",
    time: "8 months ago",
    review: "We’re super happy with Ricky and his team for delivering a quality service, with an amazing turn around time and so very flexible and accommodating to our requests. We would highly recommend and can’t wait to regularly make our event flyers, business cards, and all other printing jobs with Value Printing. Cheers 👍",
    
  },
  {
    name: "Clara Choo",
    time: "10 months ago",
    review: `Found ValuePrint by chance and probably one of the best customer services I've experienced. I've made multiple corporate bulk orders with ValuePrint and I'm beyond pleased with the quality and service rendered by Ricky. Very patient, accommodating, and helpful from start to end.

    Even if it's a large corporate order with a tight deadline (we're talking about QTY6,000 with 2 turnaround days), he'll always help to find a solution to make it happen. Highly recommend`,
   
  },
];
